// utils/fetchData.js

const fetchAcTokenData = async (endpoint, apiData = {}, accessToken = "") => {
  try {
    const headers = {
      "Content-Type": "application/json",

      "wa-platform": process.env.REACT_APP_ADMIN_SECRET,
    };


    if (accessToken) {
      headers["actoken"] = accessToken;
    }

    const response = await fetch(`${process.env.REACT_APP_URL}${endpoint}`, {
      method: "POST",

      headers,

      body: JSON.stringify(apiData),
    });


    const result = await response.json();

    return result;
  } catch (error) {
    console.log("API ERROR:", error);

    return {
      status: "error",

      msg: "Something went wrong",
    };
  }
};

export default fetchAcTokenData;
